import './App.css';


import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate, useLocation } from 'react-router-dom';
import StringsOfLanguage from './Localization';
import { ReactSession } from 'react-client-session';
import axios from 'axios';
import uuid from 'react-uuid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import LoupeHome from './components/LoupeHome';
import LoupeAbout from './components/LoupeAbout';
import LoupeHelp from './components/LoupeHelp';
import LoupeHelpButton from './components/LoupeHelpButton';
import LoupeActivityByLocation from './components/LoupeActivityByLocation';  
import LoupeActivityDetails from './components/LoupeActivityDetails'; 
import LoupeActivityContent from './components/LoupeActivityContent';
import LoupeActivityCompleted from './components/LoupeActivityCompleted';
import LoupeAppBar from './components/LoupeAppBar';
import LoupeNavigationBar from './components/LoupeNavigationBar';
import LoupeActivityByCode from './components/LoupeActivityByCode';

import Typography from '@mui/material/Typography';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Backdrop from '@mui/material/Backdrop';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import LanguageIcon from '@mui/icons-material/Language';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';

import { makeStyles } from "@mui/styles";
import createPalette from '@mui/material/styles/createPalette';
import Card from '@mui/material/Card';

import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from "@mui/material/styles";

import { useMediaQuery } from 'react-responsive';

import { Scrollbars } from 'react-custom-scrollbars-2';
import { amber, deepOrange, grey } from '@mui/material/colors';

import LoupeAppDrawerComponent from './components/LoupeAppDrawerComponent';
import LoupeInstallationPrompt from './components/LoupeInstallationPrompt';
import LoupeQrScannerComponent from './components/LoupeQrScannerComponent';
import LoupeAppInformation from './components/LoupeAppInformation';
import Loupe404PageComponent from './components/Loupe404PageComponent';
import LoupeSettings from './components/LoupeSettings';


const App = props => {
  
  
  const localizer = StringsOfLanguage;  
  const location = useLocation();

  
  ReactSession.setStoreType("localStorage");

  /* Generate a user-id that is used when providing data as key */
  if( ReactSession.get("userid") === undefined ) {
    ReactSession.set("userid", uuid());
  }

  const useridvalue = ReactSession.get("userid");

  /* simple persistence mechanism for unsubmitted data and history */
  if( ReactSession.get("prevSessionStore") === undefined ) {
    ReactSession.set("prevSessionStore", JSON.stringify({}) );
  }
  if( ReactSession.get("userHistory") === undefined ) {
    ReactSession.set("userHistory", JSON.stringify({}) );
  }

  /* User languages: persisting selection and defining available languages */
  if( ReactSession.get("userlang") === undefined || ReactSession.get("userlang").length > 2 ) {

    var clang = localizer.getInterfaceLanguage();
    if( clang.length > 2 ) {
      clang = clang.substring(0, 2);
    }

    
    ReactSession.set("userlang", clang );
  }


  // LANGUAGE, INTERNATIONALIZATION

  const [ languageLabel, setLanguageLabel ] = React.useState("");
  const importedLanguages = window.enabledLocales;
  const interfaceLanguages = [];
  const activityLanguages = [];

  

  importedLanguages.map(l => {
    if(l.isInterface) interfaceLanguages.push(l);
    if(l.isActivityLanguage) activityLanguages.push(l);
  });

  const updateActivityLanguages = () => {
    // TODO : GET ACTIVITY LANGUAGES FROM BACKEND AS IT MAKES NO SENSE TO DEFINE THIS IN FRONT-END CODE.
  }

  // set initial language of app
  var currentLanguage = interfaceLanguages.find(obj => obj.key === ReactSession.get("userlang"));
  if( currentLanguage === null || currentLanguage === undefined ) {
    // english fallback if something goes wrong
    currentLanguage = { name : 'English', key : 'en', flag : 'gb', isInterface : true, isActivityLanguage : true, };    
  }
  localizer.setLanguage( currentLanguage.key ); // used to rely on ReactSession.get("userlang")

  
  
  /* Persisting selected theme */
  if( ReactSession.get("usertheme") === undefined ) {
    ReactSession.set("usertheme", 'light' );
  }

  if( ReactSession.get("debug") === undefined ) {
    ReactSession.set("debug", 'false' );
  }
  
  const [ showCancelDialog, setShowCancelDialog] = React.useState(false);
  const [ showUploadConfirm, setShowUploadConfirm ] = React.useState(false);
  const [ showHelp, setShowHelp ] = React.useState(false);
  const [ helpTopic, setHelpTopic ] = React.useState("");
  
  const openHelpDialog = (topic) => {
    setHelpTopic(topic);
    setShowHelp(true);
  }
  
  const handleCancelActivity = () => {
    setShowDrawer(false);
    setShowCancelDialog(true);
  }
  
  const handleCancelClose = () => {
    setShowCancelDialog(false);
  }
  
  const handleHelpClose = () => {
    setShowHelp(false);
  }
  
  const handleCancel = () => {
    setShowDrawer(false);
    setShowCancelDialog(false); 
    navigate('/', { replace : true });
  }
  
  const [ hasPreviousData, setHasPreviousData ] = React.useState(false); 
  const [ numberOfPreviousKeys, setNumberOfPreviousKeys ] = React.useState(0);
  const updatePrevDataState = () => {
      var prevData = JSON.parse(ReactSession.get("prevSessionStore"));
      var nrKeys = Object.keys(prevData).length;
      if( nrKeys > 0 ) {
        setHasPreviousData(true);
        setNumberOfPreviousKeys(nrKeys);
      } else {
        setHasPreviousData(false);
        setNumberOfPreviousKeys(0);
      }
  }

  

  const handleResubmitClose = () => {
    setShowResubmitDialog(false);
  }

  const manageResubmissions = (endpoints, data) => {
    var prevData = JSON.parse(ReactSession.get("prevSessionStore"));
    endpoints.map( (obj, idx) => {
      
      if(data[idx].data == "200") {
        var cId = obj.id;
        delete prevData[cId];
      }
    });

    if(Object.keys(prevData).length == 0) {
      setShowUploadConfirm(true);
    }

    ReactSession.set("prevSessionStore", JSON.stringify(prevData));
    updatePrevDataState();
    
  }

  const handleResubmit = () => {
    setShowResubmitDialog(false);    
    var prevData = JSON.parse(ReactSession.get("prevSessionStore"));
    var uriEndpoints = [];

    Object.keys(prevData).map(d => {
      var cObj = JSON.parse(prevData[d]);    
      uriEndpoints.push({ id : d, data : cObj });      
    });

    axios.all(uriEndpoints.map((endpoint) => axios.post(endpoint.data.uri, endpoint.data.result, {
      withCredentials: true,
      headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          'LOUPE-USR-KEY' : useridvalue,
          'LOUPE-API-KEY' : 'APIKEY2',
      }

    }))).then(
        (data) => manageResubmissions(uriEndpoints, data),
    );

  }

  const navigate = useNavigate();
  const isMobileView = useMediaQuery({
    query: '(max-width: 900px)'
  })

  const isDesktopView = useMediaQuery({
      query: '(min-width: 900px)'
  })

  const isLargeDesktopView = useMediaQuery({
      query: '(min-width: 1440px)'
  })
    
  
  const [ isOpen, setIsOpen] = React.useState(false);
  const [ showResubmitDialog, setShowResubmitDialog ] = React.useState(false);

  const [showSpeedActions, setShowSpeedActions] = React.useState(false);
  const handleSpeedActionsOpen = () => setShowSpeedActions(true);
  const handleSpeedActionsClose = () => setShowSpeedActions(false);

  
  const [remountCount, setRemountCount] = useState(0);
  const refresh = () => setRemountCount(remountCount + 1);

  const [ myTheme, setMyTheme ] = useState( ReactSession.get("usertheme") );  
  const [ showDrawer, setShowDrawer ] = useState(false);

  const theme = createTheme({
    palette : {
      mode : myTheme,
      ...(myTheme === 'light'
      ? {
         primary: {
           main : "#d81b60",
         },
         secondary: {
          main : "#205F66",
         },
         tertiary: {
          main : "#FF0000",
        },
          divider: "#000000",
          text: {
            primary: grey[900],
            secondary: grey[800],
            tertiary: "#bdbdbd",
          },
        }        
      : {
          primary: { 
            main : "#ec407a" 
          },
          secondary: {
            main : "#d8b93e",
           },
           tertiary: {
            main : "#FF0000",
          },
          divider: "#ffffff",
          background: {
            default: "#222222",
            paper: "#111111",
          },
          text: {
            primary: '#fff',
            secondary: grey[500],
            tertiary: "#90a4ae",
          },
        }),
    },

    components: {
      MuiToggleButton: {
        styleOverrides: {
          root: {          
            
            "&.Mui-selected": {
              color: "#ec407a",
            },
            "&.Mui-selected:hover": {
              color: '#FF0000',
            },
            ":hover": {
                color : '#FF0000',
            },
          }
        }
      }
    }
  
  });

  const handleThemeSelection = mode => {
    ReactSession.set("usertheme", mode );
    setMyTheme(mode);
    setShowDrawer(false);
  }


  const handleLanguageChange = (key, name) => {  
    setLanguageLabel(name);    
    localizer.setLanguage(key);
    ReactSession.set("userlang", key);
    setShowDrawer(false);
    handleSpeedActionsClose();
    refresh();
  }

  const getAppLanguage = () => {
    return(localizer.getLanguage());
  }
  const getAppInterfaceLanguage = () => {
    return(localizer.getInterfaceLanguage());
  }

 
  const languageContextValue = {
    strings : localizer,
    setLanguage : handleLanguageChange,
    getLanguage : getAppLanguage,
    getInterfaceLanguage : getAppInterfaceLanguage,
  }

  const openDataProtectionInformation = () => {
    setShowDrawer(false);
    var uri = process.env.REACT_APP_BASE_URI + "/" + localizer.getLanguage() + "_" + process.env.REACT_APP_GDPR_FILENAME_SUFFIX; 
    window.open(uri);
  }


  

  const bg = (theme.palette.mode == 'light') ? "#fff" : "#121212";
  const pbg = (theme.palette.mode == 'light') ? "whitesmoke" : "#050505";
  const linkcolor = (theme.palette.mode == 'light') ? "#000" : "#fff";

  const useStyles = makeStyles({            
      root: {
        backgroundColor : bg,        
      },
      ll: {
        textDecoration : "none",
        color : linkcolor,
      },
      pagebb: {
        backgroundColor : pbg,
        height: "100vh",
      },
    
    });

    const classes = useStyles();

    useEffect(() => {

      if ("geolocation" in navigator) { 

          navigator.geolocation.getCurrentPosition(
              (position) => {},
              () => {},
              { enableHighAccuracy: true, timeout : 10000 }            
          );
      }

    }, []);

    useEffect(() => {        
      updatePrevDataState();  
      setLanguageLabel(currentLanguage.name);  
    }, [location]);
    
    return (

      <LocalizationContext.Provider value={languageContextValue}>
        <LocalizationContext.Consumer>

          { ({strings, setLanguage}) =>   
          
          
          
            <ThemeProvider theme={theme}>
              <div className={classes.pagebb}>
  
              <div className="App">

                <LoupeAppDrawerComponent
                    setShowDrawerCallback={setShowDrawer}
                    showDrawer={showDrawer}
                    GdprCallback={openDataProtectionInformation}
                    themeCallback={handleThemeSelection}
                    cancelCallback={handleCancel}
                    cancelActivityCallback={handleCancelActivity} />
                
                <AppBar    
                  className={classes.root}
                  position="static" >
                
                  <Paper elevation={0} square>
                    <Toolbar>

                      <IconButton
                        color="primary"
                        onClick={() => setShowDrawer(true)}
                        size="large"
                        edge="start"
                        aria-label="menu"
                        sx={{ mr: 2 }}>
                        <MenuIcon/>
                      </IconButton>                       

                  <Routes>
                  
                    {
                        ["/", "/settings", "/about", "/scan", "/activities-here", "/about-app", "/activity-complete"].map((path,index) => {
                            return (
                                <Route path={path} element={
                                  <>

                                    { ( hasPreviousData && path == "/" ) && 
                                      <Button onClick={() => setShowResubmitDialog(true)} >
                                        {numberOfPreviousKeys + "  "}
                                        <AnnouncementIcon color="primary"/>
                                      </Button>
                                    } 


                                    <LoupeAppBar />

                                    <Stack direction="row" sx={{ marginLeft: "auto" }}>
                                      
                                      { process.env.REACT_APP_ENABLE_HELP == "TRUE" && 
                                         <LoupeHelpButton topic={path} openHelpDrawbackHandler={openHelpDialog} />                                                                                                       
                                      }

                                      <Button  onClick={() => setIsOpen(true)} >
                                        {languageLabel}&nbsp;&nbsp;
                                        <LanguageIcon />
                                      </Button>   
                                      
                                    </Stack>

                                                                   
                                  </>
                                } key={index} />
                            );
                        }
                    )}
                    
                    <Route path={`/activity-details/:language/:activityCode`} element={<LoupeAppBar />}/>
                                   
                  </Routes> 
                  
       
                  </Toolbar>

                </Paper>
              </AppBar>
                
              <Paper elevation={0} square className="pageend">                                         
                  <Routes>
                    <Route path={'*'} element={<Loupe404PageComponent />} />
                    <Route exact path={`/`} element={<LoupeHome uploadCallback={setShowResubmitDialog} theme={myTheme} />} />
                    <Route exact path={`/about`} element={<LoupeAbout />} />
                    <Route exact path={`/scan`} element={<LoupeQrScannerComponent />} />
                    <Route exact path={'/settings'} element={<LoupeSettings />} />
                    <Route exact path={`/activities-here`} element={<LoupeActivityByLocation language={localizer.getLanguage()} availableLanguages={activityLanguages} />} />
                    <Route exact path={`/activity-details/:language/:activityCode`} element={<LoupeActivityDetails />}/>
                    <Route exact path={`/activity-content/:language/:activityCode`} element={<LoupeActivityContent />}/>
                    <Route exact path={`/activity-complete`} element={<LoupeActivityCompleted />}/>
                    <Route exact path={`/start/:activityCode`} element={<LoupeActivityByCode />} />
                    <Route exact path={`/about-app`} element={<LoupeAppInformation />} />
                  </Routes>
              </Paper>


              <Divider />

              <footer className="text-muted">

                <div>                                
                  { interfaceLanguages &&
                      <div>

                          <Dialog open={isOpen}>
                              <DialogTitle>{strings.getString("dialogs.language.selection.title")}</DialogTitle>
                              <List sx={{ pt: 0 }}>
                              { interfaceLanguages.map(l => {
                                      return(
                                          <ListItem button key={l.key}>
                                              <ListItemText onClick={() => {handleLanguageChange(l.key, l.name); setIsOpen(false); }} primary={l.name}/>
                                          </ListItem>
                                      )
                                  })}

                                  <Divider />
                                  <ListItem button key={'cancel_language_selection'}>
                                    <ListItemText onClick={() => setIsOpen(false)} primary={strings.getString("controls.buttons.cancel")}/>
                                  </ListItem>

                              </List>
                          </Dialog>
                      </div>
                  }
                </div>
                                              
              </footer>

              <Routes>
                <Route path={`/`} element={<LoupeNavigationBar tab={0} />} />
                <Route path={`/about`} element={<LoupeNavigationBar tab={1} />} />
                <Route path={`/activities-here`} element={<LoupeNavigationBar tab={2} />} />
                <Route path={`/scan`} element={<LoupeNavigationBar tab={3} />} />
              </Routes>

              </div>

              <Backdrop open={(showHelp || showCancelDialog || showResubmitDialog || showUploadConfirm)} sx={{color : '#000'}} />
              
              <LoupeHelp 
                isOpen={showHelp}
                closeDrawerCallback={setShowHelp}
                topic={helpTopic} />                          
              
              <Dialog
                open={showCancelDialog}                      
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
              
                <DialogTitle id="alert-dialog-title">
                  {strings.getString("dialogs.activity.cancel.title")}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {strings.getString("dialogs.activity.cancel.message")}
                  </DialogContentText>                  
                </DialogContent>

                <DialogActions>
                  <Button onClick={handleCancelClose}>{strings.getString("controls.buttons.no")}</Button>
                  <Button onClick={handleCancel} autoFocus>
                    {strings.getString("controls.buttons.yes")}
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={showResubmitDialog}                      
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
              
                <DialogTitle id="alert-dialog-title">
                  {strings.getString("dialogs.resubmission.upload.title")}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {strings.getString("dialogs.resubmission.upload.message")}
                  </DialogContentText>                  
                </DialogContent>

                <DialogActions>
                  <Button onClick={handleResubmitClose}>{strings.getString("controls.buttons.no")}</Button>
                  <Button onClick={handleResubmit} autoFocus>
                    {strings.getString("controls.buttons.yes")}
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                  open={showUploadConfirm}                      
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description">
                
                  <DialogTitle id="alert-dialog-title">      
                      {strings.getString("dialogs.resubmission.complete.title")}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {strings.getString("dialogs.resubmission.complete.message")}
                    </DialogContentText>                  
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={() => setShowUploadConfirm(false)} autoFocus>
                      {"OK"}
                    </Button>
                  </DialogActions>
                </Dialog>

                

            </div>
          </ThemeProvider>
          }
        </LocalizationContext.Consumer>    
      </LocalizationContext.Provider>
     
      
  );
 
  
}


export const LocalizationContext = new React.createContext(
  { 
    strings : null, 
    setLanguage : (key) => {}, 
    getLanguage : () => {},
    getInterfaceLanguage : () => {}, 
  }
);
export default App;
